// @ts-nocheck
import React, { PureComponent } from 'react';
import clipboard from 'clipboard-js';
import dynamic from 'next/dynamic';

import cn from 'classnames';
import MediaQuery from 'react-responsive';
import {
    Tabs, PanelList,
    TabList,
    Tab,
    Panel,
} from 'react-tabtab';
import merge from 'lodash/merge';
import includes from 'lodash/includes';
import Poppop from 'react-poppop';
import { Trans, t } from '@lingui/macro';

import WeekDeal from '../components/WeekDeal';
import HourDeal from '../components/HourDeal';
import ODrank from '../components/ODrank';
import SelectStation from '../components/od/SelectStation';
import {
    stationIdToName, numberToSplitExpress, getWindowWidth, getWindowHeight,
} from '../utils';
import { trackBothEvent, gaEvent } from '../utils/track';
import * as customStyle from '../components/styledTabTab';
import styles from './Od.module.scss';

const OdMap = dynamic(
    () => import('../components/OdMap'),
    { ssr: false },
);
class OdContent extends PureComponent {
    constructor(props) {
        super(props);
        const { config, currentStation } = props;
        const selectYearMonthStringify = config.dateRange.map((item) => `${item.year}${item.month}`);
        this.state = {
            currentStation: currentStation || 'all',
            showBorrow: true,
            showReturn: true,
            highlight: false,
            hideOtherStation: false,
            selectYearMonth: merge([], config.dateRange), // to ensure deep duplicate
            selectYearMonthStringify,
            mobileMore: false,
            isSelectDateOpen: false,
            hideLeftSide: false,
            highlightedStation: {
                type: null,
                station: null,
            },
        };
    }

    componentWillMount() {
    // var padding = 20;
        this.width = getWindowWidth();
        this.windowWidth = this.width / 4;
        this.leftWidth = 480; // this.width / 4 - 2*padding;
        this.rightWidth = 344; // this.width / 5 - 2*padding;
        this.height = getWindowHeight();
    }

    componentWillReceiveProps(nextProps) {
        const { currentStation } = this.props;
        if (nextProps.currentStation && nextProps.currentStation !== currentStation) {
            this.setState({ currentStation: nextProps.currentStation });
        }
    }

    handleClickStation = (station) => {
        this.setState({
            currentStation: station,
            hideOtherStation: false,
            showBorrow: true,
            showReturn: true,
        });
        trackBothEvent('Od', 'Click Station', parseInt(station, 10));
    }

    changeSelectMobile = (e) => {
        const { value } = e.target;
        this.changeSelect(value);
    }

    changeSelect = (currentStation) => {
        const { availableTime, config } = this.props;
        // when select new station, reset the current select station to select available all
        const selectYearMonth = [];
        const selectYearMonthStringify = [];

        if (currentStation === 'all') {
            config.dateRange.forEach((item) => {
                const { year, month } = item;
                selectYearMonth.push({ year, month });
                selectYearMonthStringify.push(`${year}${month}`);
            });
        } else {
            availableTime[currentStation].forEach((item) => {
                const { year, month } = item;
                selectYearMonth.push({ year, month });
                selectYearMonthStringify.push(`${year}${month}`);
            });
        }

        this.setState({
            currentStation,
            selectYearMonth,
            selectYearMonthStringify,
            hideOtherStation: false,
            showBorrow: true,
            showReturn: true,
        });
        trackBothEvent('Od', 'Select Station', parseInt(currentStation, 10));
    }

    handleClickBorrow = () => {
        const { showBorrow } = this.state;
        this.setState({ showBorrow: !showBorrow });
        trackBothEvent('Od', 'Show/Hide Borrow');
    }

    handleClickReturn = () => {
        const { showReturn } = this.state;
        this.setState({ showReturn: !showReturn });
        trackBothEvent('Od', 'Show/Hide Return');
    }

    handleHighlight = (highlight) => {
        this.setState({ highlight });
        gaEvent('Od', 'Highlight Station');
    }

    toggleHideOtherStation = () => {
        const { hideOtherStation } = this.state;
        this.setState({ hideOtherStation: !hideOtherStation });
        trackBothEvent('Od', 'Hide Other Station');
    }

    toggleSelectDate = (value) => {
        this.setState({ isSelectDateOpen: value });
    }

    toggleLeftSide = (value) => {
        this.setState({ hideLeftSide: value });
    }

    toggleRightSide = (value) => {
        this.setState({ hideRightSide: value });
    }

    generateSelectRange = () => {
        const { selectYearMonthStringify, currentStation } = this.state;
        const {
            odCount, availableTime, sortedDateRange, monthDeal, config,
        } = this.props;

        const availableMonthYear = []; // 存有交易紀錄的年月（因為有些站點是新設的，較早期的時間沒有資料）
        if (currentStation === 'all') {
            if (odCount[currentStation]) {
                Object.keys(odCount[currentStation]).forEach((year) => {
                    Object.keys(odCount[currentStation][year]).forEach((month) => {
                        availableMonthYear.push(`${year}${month}`);
                    });
                });
            }
        } else {
            availableTime[currentStation].forEach((item) => {
                const { year, month } = item;
                availableMonthYear.push(`${year}${month}`);
            });
        }
        // TODO: turn off this part for now. Since I think this feature may not be necessary
        // if it is across different date & year, show slection
        if (false && config.dateRange.length > 1) {
            const body = (
                <div className="od-popdate-wrapper">
                    <h4>
                        <Trans id="od.selectMonthTitle" />
                    </h4>
                    <div style={{ maxHeight: `${this.height - 200}px`, overflow: 'scroll' }}>
                        <table className="table" style={{ textAlign: 'left' }}>
                            <tbody>
                                {sortedDateRange.map(({ year, month }) => {
                                    let disabled = false;
                                    let active = false;
                                    const monthYear = `${year}${month}`;
                                    if (selectYearMonthStringify.indexOf(monthYear) >= 0) active = true;
                                    if (!includes(availableMonthYear, monthYear) && currentStation !== 'all') disabled = true;
                                    if (!disabled) {
                                        return (
                                            <tr key={`${year}/${month}`}>
                                                <td className={styles.popdateItem}>
                                                    <input
                                                        type="checkbox"
                                                        checked={active}
                                                        onChange={this.changeDate.bind(this, year, month, active)}
                                                    />
                                                    <label>{`${year}/${month}`}</label>
                                                </td>
                                                <td>{numberToSplitExpress(monthDeal[year][month])}</td>
                                            </tr>
                                        );
                                    }
                                })}
                            </tbody>
                        </table>
                    </div>
                    <button type="button" className={cn('btn btn-default', styles.btnDateEnsure)} onClick={() => this.toggleSelectDate(false)}>ok</button>
                </div>
            );
            return (
                <div>
                    <button
                        type="button"
                        className="btn btn-default btn-xs"
                        onClick={() => this.toggleSelectDate(true)}
                        style={{ marginTop: '5px' }}
                    >
                        <i className="fa fa-calendar" />
                        {' '}
                        <Trans id="od.selectMonth" />
                    </button>
                    <Poppop
                        open={this.state.isSelectDateOpen}
                        position="centerCenter"
                        onClose={() => this.toggleSelectDate(false)}
                    >
                        {body}
                    </Poppop>
                </div>
            );
        }
        return null;
    }

    changeDate = (year, month, active) => {
        const { selectYearMonth, selectYearMonthStringify } = this.state;
        if (active) {
            for (const i in selectYearMonth) {
                if (selectYearMonth[i].year === year && selectYearMonth[i].month === month) {
                    selectYearMonth.splice(i, 1);
                    break;
                }
            }
            const index = selectYearMonthStringify.indexOf(`${year}${month}`);
            selectYearMonthStringify.splice(index, 1);
        } else {
            selectYearMonth.push({ year, month });
            selectYearMonthStringify.push(`${year}${month}`);
        }
        this.setState({ selectYearMonth, selectYearMonthStringify });
        trackBothEvent('Od', 'Change Date');
    }

    handleMouseEnterStation = (key, type) => {
        this.setState({
            highlightedStation: {
                type,
                station: key,
            },
        });
    }

    handleMouseLeaveStation = () => {
        this.setState({
            highlightedStation: {
                type: null,
                station: null,
            },
        });
    }

    handleShareStation = () => {
        const that = this;
        const { lang, system } = this.props;
        const { currentStation } = this.state;
        if (currentStation !== 'all') {
            clipboard.copy({
                'text/plain': `https://www.visualization.bike/${lang}/${system}/od/${currentStation}`,
            })
                .then(
                    () => {
                        that.refs.container.success(
                            'Copy this station link!', '', {
                                timeOut: 3000,
                                extendedTimeOut: 10000,
                            },
                        );
                    },
                    (err) => {
                        console.error('failure', err);
                    },
                );
        }
        trackBothEvent('Od', 'Share Station', parseInt(currentStation, 10));
    }

    toggleMobileMore = () => {
        const { mobileMore } = this.state;
        this.setState({ mobileMore: !mobileMore });
    }

    render() {
        const {
            config,
            stationlist,
            isMobile,
            geo,
            odCount,
            stationDeal,
            odMovingTime,
            stationWdayDeal,
            hourlyDeal,
            stationHourDeal,
        } = this.props;
        const {
            showBorrow,
            showReturn,
            highlight,
            selectYearMonth,
            hideOtherStation,
            currentStation,
            mobileMore,
            hideLeftSide,
            hideRightSide,
            highlightedStation,
        } = this.state;
        const option = [];
        option.push(
            <option value="all" key="all">
                {t({ id: 'od.allstation' })}
            </option>,
        );
        for (const key in stationlist) {
            if (stationlist[key]) {
                const station = stationlist[key];
                const n = geo[station];
                option.push(<option value={station} key={station}>{n.station}</option>);
            }
        }

        return (
            <div>
                <OdMap
                    config={config}
                    geo={geo}
                    stationlist={stationlist}
                    odCount={odCount}
                    station={currentStation}
                    stationDeal={stationDeal}
                    odMovingTime={odMovingTime}
                    handleClickStation={this.handleClickStation}
                    highlight={this.handleHighlight}
                    selectYearMonth={selectYearMonth}
                    showBorrow={showBorrow}
                    showReturn={showReturn}
                    hideOtherStation={hideOtherStation}
                    isMobile={isMobile}
                    highlightedStation={highlightedStation}
                />
                <MediaQuery query="(min-device-width: 769px)">
                    <div>
                        {hideLeftSide
                            ? (
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    style={{ marginTop: '10px' }}
                                    onClick={() => this.toggleLeftSide(false)}
                                >
                                    <i className="fa fa-chevron-right fx-lg" />
                                </button>
                            )
                            : (
                                <div className={styles.dataDetail} style={{ width: `${this.windowWidth}px` }}>
                                    <div style={{ width: '100%' }}>
                                        <button
                                            type="button"
                                            className="btn btn-default"
                                            style={{ position: 'absolute', right: '0', top: '0' }}
                                            onClick={() => this.toggleLeftSide(true)}
                                        >
                                            <i className="fa fa-chevron-left fx-lg" />
                                        </button>
                                        <div className="row">
                                            <div className="col-md-10">
                                                {/* <h2 className="h3">{stationIdToName({ id: currentStation, geo, t })}</h2> */}
                                            </div>
                                            <div className="col-md-2">
                                                {currentStation !== 'all' ? (
                                                    <button
                                                        type="button"
                                                        className="btn btn-link btn-lg"
                                                        onClick={this.handleShareStation}
                                                        style={{ color: 'white' }}
                                                    >
                                                        <i className="fa fa-share-square-o" />
                                                    </button>
                                                )
                                                    : null}
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <SelectStation
                                                value={currentStation}
                                                onChange={this.changeSelect}
                                                stationlist={stationlist}
                                                geo={geo}
                                            />
                                        </div>
                                        {this.generateSelectRange()}
                                        <HourDeal
                                            station={currentStation}
                                            selectYearMonth={selectYearMonth}
                                            stationHourDeal={stationHourDeal}
                                            width={this.leftWidth}
                                        />
                                        <WeekDeal
                                            station={currentStation}
                                            stationWdayDeal={stationWdayDeal}
                                            selectYearMonth={selectYearMonth}
                                            width={this.leftWidth}
                                        />
                                    </div>
                                </div>
                            )}
                        {currentStation !== 'all'
                            ? (
                                <div>
                                    {hideRightSide
                                        ? (
                                            <button
                                                type="button"
                                                className="btn btn-default"
                                                style={{ float: 'right', marginTop: '10px' }}
                                                onClick={() => this.toggleRightSide(false)}
                                            >
                                                <i className="fa fa-chevron-left fx-lg" />
                                            </button>
                                        )
                                        : (
                                            <div id="odDetail" className={styles.odDetail} style={{ width: `${this.rightWidth}px` }}>
                                                <button
                                                    type="button"
                                                    className="btn btn-default"
                                                    style={{ position: 'absolute', left: '0', top: '0' }}
                                                    onClick={() => this.toggleRightSide(true)}
                                                >
                                                    <i className="fa fa-chevron-right fx-lg" />
                                                </button>
                                                <div className="row">
                                                    <div className="col col-md-12">
                                                        <ODrank
                                                            station={currentStation}
                                                            selectYearMonth={selectYearMonth}
                                                            geo={geo}
                                                            odCount={odCount}
                                                            showBorrow={showBorrow}
                                                            showReturn={showReturn}
                                                            highlight={highlight}
                                                            hideOtherStation={hideOtherStation}
                                                            toggleHideOtherStation={this.toggleHideOtherStation}
                                                            handleClickBorrow={this.handleClickBorrow}
                                                            handleClickReturn={this.handleClickReturn}
                                                            handleMouseEnterStation={this.handleMouseEnterStation}
                                                            handleMouseLeaveStation={this.handleMouseLeaveStation}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                </div>
                            )
                            : null}
                        <div className="modal fade bs-example-modal-lg" role="dialog" aria-labelledby="myLargeModalLabel">
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <h4 className="modal-title" id="myModalLabel">Bike Visualization</h4>
                                    </div>
                                    <div className="modal-body">
                                        <p>The visualization map shows the related information based on different bike sharing data.</p>
                                        <p>On the left panel, it shows three inforamtion:</p>
                                        <ul>
                                            <li>
                                                <b>Week deal</b>
                                                ：borrow bike and return bike at each weekday and weekend.
                                            </li>
                                            <li>
                                                <b>Hour borrow</b>
                                                ：total borrow bike at each hour.
                                            </li>
                                            <li>
                                                <b>Hour return</b>
                                                ：total return bike at each hour.
                                            </li>
                                        </ul>
                                        <hr />
                                        <p>On the right panel, it shows the origin-destination relation of each station.</p>
                                        <p>You can click the blue circle on the map to change selected station.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </MediaQuery>
                <MediaQuery query="(max-device-width: 768px)">
                    <div>
                        <div className={styles.wrapper}>
                            <div className="row">
                                <div className="col-sm-12 col-8">
                                    <select
                                        className={cn('form-control', styles.odSelectStation)}
                                        onChange={this.changeSelectMobile}
                                        value={currentStation}
                                    >
                                        {option}
                                    </select>
                                </div>
                                {currentStation !== 'all'
                                    ? (
                                        <div className="col-xs-4">
                                            <button type="button" className="btn btn-primary" onClick={this.toggleMobileMore}>
                                                {mobileMore
                                                    ? <i className="fa fa-times" />
                                                    : (
                                                        <span>
                                                            <Trans id="od.moreInfo" />
                                                        </span>
                                                    )}
                                            </button>
                                        </div>
                                    )
                                    : null}
                            </div>
                            {mobileMore
                                ? (
                                    <Tabs customStyle={customStyle}>
                                        <TabList>
                                            <Tab active><Trans id="od.activity" /></Tab>
                                            <Tab><Trans id="od.odRank" /></Tab>
                                        </TabList>
                                        <PanelList>
                                            <Panel title="need.to.change.activity.title">
                                                <div>
                                                    <HourDeal
                                                        station={currentStation}
                                                        selectYearMonth={selectYearMonth}
                                                        stationHourDeal={stationHourDeal}
                                                        width={this.leftWidth}
                                                    />
                                                </div>
                                                <div>
                                                    <WeekDeal
                                                        station={currentStation}
                                                        stationWdayDeal={stationWdayDeal}
                                                        selectYearMonth={selectYearMonth}
                                                        width={this.leftWidth}
                                                    />
                                                </div>
                                            </Panel>
                                            <Panel title="need.to.change.od.title">
                                                <ODrank
                                                    station={currentStation}
                                                    selectYearMonth={selectYearMonth}
                                                    geo={geo}
                                                    odCount={odCount}
                                                    showBorrow={showBorrow}
                                                    showReturn={showReturn}
                                                    highlight={highlight}
                                                    hideOtherStation={hideOtherStation}
                                                    toggleHideOtherStation={this.toggleHideOtherStation}
                                                    handleClickBorrow={this.handleClickBorrow}
                                                    handleClickReturn={this.handleClickReturn}
                                                    handleMouseEnterStation={this.handleMouseEnterStation}
                                                    handleMouseLeaveStation={this.handleMouseLeaveStation}
                                                    isMobile
                                                />
                                            </Panel>
                                        </PanelList>
                                    </Tabs>
                                )
                                : null}
                        </div>
                    </div>
                </MediaQuery>
                {/* <ToastContainer
                    ref="container"
                    toastMessageFactory={ToastMessageFactory}
                    className="toast-top-right"
                /> */}
            </div>
        );
    }
}

export default (OdContent);
